import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { postChangePassword } from '../accountPage.api';
import { ManageAccountLeft, SubMenuAccountComponent } from '../common';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';

function ChangePasswordComponent() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { t } = useTranslation();
  const initialValues = {
    CurrentPass: '',
    NewPass: '',
    rePassword: '',
  };

  const validationSchema = Yup.object().shape({
    CurrentPass: Yup.string().required(t('manage_account.label_currentPassRequired')),
    NewPass: Yup.string()
      .required(t('manage_account.label_newPassRequired'))
      .when('CurrentPass', {
        is: val => (val && val.length > 0 ? true : false),
        then: Yup.string().notOneOf([Yup.ref('CurrentPass')], t('manage_account.label_checkNewPass')),
      })
      .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,48}$/, t('manage_account.label_validatePass'))
      .min(8, t('manage_account.label_validatePass'))
      .max(48, t('manage_account.label_validatePass')),
    rePassword: Yup.string()
      .required(t('manage_account.label_rePassRequired'))
      .when('NewPass', {
        is: val => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf([Yup.ref('NewPass')], t('manage_account.label_checkRePass')),
      })
      .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,48}$/, t('manage_account.label_validatePass'))
      .min(8, t('manage_account.label_validatePass'))
      .max(48, t('manage_account.label_validatePass')),
  });

  const submitForm = (values, { resetForm }) => {
    showLoader();
    let FormData = require('form-data');
    let data = new FormData();

    data.append('CurrentPass', values.CurrentPass);
    data.append('NewPass', values.NewPass);

    postChangePassword(data)
      .then(res => {
        if (res.status === 'success') {
          onSuccess();
          resetForm({});
        } else {
          onError();
        }
      })
      .catch(err => {
        if (err === 500) {
          onError();
        }
      });
  };

  const messageSuccess = (
    <>
      <div>{t('manage_account.label_passSuccess')}</div>
    </>
  );

  const messageError = (
    <>
      <div>{t('manage_account.label_currentPassIsIncorrect')}</div>
    </>
  );

  const onSuccess = () => {
    hideLoader();
    toast.success(messageSuccess, { autoClose: 5000 });
  };
  const onError = () => {
    hideLoader();
    toast.error(messageError, { autoClose: 5000 });
  };

  return (
    <>
      <SubMenuAccountComponent />
      <div id="manageAccount" className="container">
        <div className="row mx-0 d-block d-md-flex">
          {/* Left */}
          <ManageAccountLeft />

          {/* Right */}
          <div className="col-8 pr-0 pl-3">
            <div className="personal-detail__right">
              <div className="personal-detail__right-title">{t('manageAccount.label_changePassword')}</div>

              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={submitForm}
              >
                {formik => {
                  const { errors, touched, handleChange, handleBlur, values } = formik;

                  return (
                    <Form>
                      <div className="form-group">
                        <label className="form-group__label">
                          {t('manageAccount.label_currentPassword')} <span className="required-star">*</span>
                        </label>
                        <Field
                          type="password"
                          name="CurrentPass"
                          className={
                            errors.CurrentPass && touched.CurrentPass ? 'form-control input-error' : 'form-control'
                          }
                          maxLength={48}
                          value={values.CurrentPass || ''}
                        />
                        <ErrorMessage name="CurrentPass" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <label className="form-group__label">
                          {t('manageAccount.label_newPassword')} <span className="required-star">*</span>
                        </label>
                        <Field
                          type="password"
                          name="NewPass"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          className={errors.NewPass && touched.NewPass ? 'form-control input-error' : 'form-control'}
                          maxLength={48}
                        />
                        <ErrorMessage name="NewPass" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <label className="form-group__label">
                          {t('manageAccount.label_rePassword')} <span className="required-star">*</span>
                        </label>
                        <Field
                          type="password"
                          name="rePassword"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          className={
                            errors.rePassword && touched.rePassword ? 'form-control input-error' : 'form-control'
                          }
                          maxLength={48}
                        />
                        <ErrorMessage name="rePassword" component="span" className="error" />
                      </div>

                      <div className="d-flex justify-content-end button-confirm-page pt-3">
                        <button type="reset" className="personal-detail__right-button_cancel">
                          {t('manageAccount.label_clear')}
                        </button>

                        <button type="submit" className="personal-detail__right-button_save">
                          {t('manageAccount.label_save')}
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
}

export default ChangePasswordComponent;
